import React from "react";
import { motion } from "framer-motion";

const InclusiveWorkplace = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 },
        },
    };

    const fadeUpVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
    };

    return (
        <section className="w-full bg-white py-12 md:py-16 px-5 sm:px-10 lg:px-[80px] text-left relative z-10 font-sans overflow-hidden">
            <div className="max-w-[1440px] mx-auto w-full relative min-h-[320px] sm:min-h-[400px] md:min-h-[460px] lg:min-h-[500px] bg-[#0c4a6e] p-6 sm:p-10 md:p-16 lg:p-20 flex items-center">

                <div className="absolute inset-0 w-full h-full pointer-events-none opacity-40 sm:opacity-50">
                    <img
                        src="/assets/diversity/img8.png"
                        alt="Abstract modern architectural glass facade background"
                        className="w-full h-full object-cover object-center"
                    />
                </div>
                <div className="absolute inset-0 bg-black/30 sm:bg-transparent pointer-events-none z-10" />

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    className="w-full max-w-[760px] flex flex-col gap-4 sm:gap-6 relative z-20"
                >
                    <motion.h2
                        variants={fadeUpVariants}
                        className="text-[20px] md:text-[30px] font-[600] font-sora text-white leading-tight tracking-tight break-words w-full"
                    >
                        Creating an Inclusive Workplace
                    </motion.h2>

                    <motion.p
                        variants={fadeUpVariants}
                        className="text-[14px] md:text-[18px] font-graphik text-white leading-relaxed font-[500] max-w-[579px] break-words w-full"
                    >
                        With a deep understanding and commitment to building an inclusive culture, we continue to incorporate more sustainable improvements in our workplace. The efforts of each of our employees help us drive change and create a haven of an inclusive workplace.
                    </motion.p>
                </motion.div>

            </div>
        </section>
    );
};

export default InclusiveWorkplace;